export function getType (val) {
  return val::Object.prototype.toString().slice(8, -1)
}

export function isType (val, type) {
  return getType(val) === type
}

export function isArray (val) {
  return Array.isArray(val)
}

export function isPromise (val) {
  return getType(val) === 'Promise'
}

export function isImage (name) {
  const imageExtension = [
    'bmp',
    'jpg',
    'jpeg',
    'png',
    'gif',
  ]
  const extension = name?.split('.').pop()
    .toLocaleLowerCase()

  return imageExtension.includes(extension)
}

export function isDOM (val) {
  return val instanceof Node
}

export function isBool (val) {
  return getType(val) === 'Boolean'
}

export function isBlob (val) {
  return getType(val) === 'Blob'
}

export function isFile (val) {
  return getType(val) === 'File'
}

export function isObject (val) {
  return getType(val) === 'Object'
}

export function isFormData (val) {
  return getType(val) === 'FormData'
}

export function isInteger (val) {
  return String(val).indexOf('.') === -1
}

export function isFloat (val) {
  return !isInteger(val)
}

export function isFunction (val) {
  return typeof val === 'function'
}

export function isString (val) {
  return typeof val === 'string'
}

export function isNumber (val) {
  return typeof val === 'number'
}

export function isDef (val) {
  return val !== undefined && val !== null
}

export function isValue (val) {
  return isDef(val) && val !== ''
}

export function isUndef (val) {
  return !isDef(val)
}

// eslint-disable-next-line no-useless-escape
export const URL_REG = /^((ht|f)tps?):\/\/([\w\-]+(\.[\w\-]+)*\/)*[\w\-]+(\.[\w\-]+)*\/?(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?/
export function isURL (val = '') {
  return !!val.match(URL_REG)
}

export function isUndefined (val) {
  return val === undefined
}

export function isNull (val) {
  return val === null
}

export function isEmpty (val) {
  if (isObject(val)) {
    return !Object.keys(val).length
  }

  if (isArray(val)) {
    return !val.length
  }
}

export function isError (val) {
  return getType(val) === 'Error'
}

export function isDate (val) {
  return getType(val) === 'Date'
}

export function isValidDate (date) {
  if (isDate(date)) {
    return true
  }

  if (!date) {
    return false
  }

  if (!isNaN(date)) {
    // 小于13位数字不认为是毫秒数
    if (String(date).length < 13) {
      return false
    }
  }

  if (isUndef(date)) {
    return false
  }

  if (!isDate(new Date(date))) {
    return false
  }

  if (isNaN(new Date(date).getTime())) {
    return false
  }

  return true
}

export const PHONE_REG = /^[0-9]{11}$/g
export function isPhone (val = '') {
  return !!String(val).match(PHONE_REG)
}

// 维吾尔族人民包含·
export const NAME_REG = /^[·\u4e00-\u9fa5]{1,20}$/g
export function isName (val = '') {
  return !!String(val).match(NAME_REG)
}

export const POSTAL_CODE_REG = /^[0-9]{6}$/g
export function isPostalCode (val = '') {
  return !!String(val).match(POSTAL_CODE_REG)
}

export const MAIL_CODE_REG = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/g
export function isMailCode (val = '') {
  return !!String(val).match(MAIL_CODE_REG)
}

export const ID_REG = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/g
export function isIdentity (val = '') {
  // return !!String(val).match(ID_REG)
  return checkCard(String(val))
}

export function _isNaN (val) {
  if (isNumber(val)) {
    return false
  }

  if (isString(val) && !isNaN(val)) {
    return false
  }

  return true
}

export function isBase64 (v, opts = {}) {
  if (v instanceof Boolean || typeof v === 'boolean') {
    return false
  }

  if (!(opts instanceof Object)) {
    opts = {}
  }

  if (opts.allowEmpty === false && v === '') {
    return false
  }

  let regex = '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+/]{3}=)?'
  const mimeRegex = '(data:\\w+\\/[a-zA-Z\\+\\-\\.]+;base64,)'

  if (opts.mimeRequired === true) {
    regex = mimeRegex + regex
  } else if (opts.allowMime === true) {
    regex = `${mimeRegex}?${regex}`
  }

  if (opts.paddingRequired === false) {
    regex = '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}(==)?|[A-Za-z0-9+\\/]{3}=?)?'
  }

  return (new RegExp(`^${regex}$`, 'gi')).test(v)
}

export function isDynamicVariableString (val = '') {
  return isString(val) && val.startsWith('$_')
}

export function isDynamicApiString (val = '') {
  return isString(val) && val.startsWith('url_')
}

export const isEmptyAll = (val) => {
  return isEmpty(val) || !isValue(val)
}

export const getIsWxClient = () => {
  const ua = navigator.userAgent.toLowerCase()

  if (ua.indexOf('micromessenger') >= 0 || ua.indexOf('wechatdevtools') >= 0) {
    return true
  }

  return false
}

export const getIsAli = () => {
  const ua = navigator.userAgent.toLowerCase()

  if (ua.indexOf('alipayclient') >= 0) {
    return true
  }

  return false
}

export const getIsMobile = () => {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}

export const getIsIos = () => {
  const ua = navigator.userAgent
  const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端

  return isiOS
}

export function isEmail (val = '') {
  const EMAIL_REG = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/

  return EMAIL_REG.test(val)
}

// 校验身份证
const vcity = {
  11: '北京',
  12: '天津',
  13: '河北',
  14: '山西',
  15: '内蒙古',
  21: '辽宁',
  22: '吉林',
  23: '黑龙江',
  31: '上海',
  32: '江苏',
  33: '浙江',
  34: '安徽',
  35: '福建',
  36: '江西',
  37: '山东',
  41: '河南',
  42: '湖北',
  43: '湖南',
  44: '广东',
  45: '广西',
  46: '海南',
  50: '重庆',
  51: '四川',
  52: '贵州',
  53: '云南',
  54: '西藏',
  61: '陕西',
  62: '甘肃',
  63: '青海',
  64: '宁夏',
  65: '新疆',
  71: '台湾',
  81: '香港',
  82: '澳门',
  91: '国外',
}

export const checkCard = (obj) => {
  // 校验长度，类型
  if (isCardNo(obj) === false) {
    return false
  }

  // 检查省份
  if (checkProvince(obj) === false) {
    return false
  }

  // 校验生日
  if (checkBirthday(obj) === false) {
    return false
  }

  // 检验位的检测
  if (checkParity(obj) === false) {
    return false
  }

  return true
}

// 检查号码是否符合规范，包括长度，类型
function isCardNo (obj) {
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
  const reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/

  if (reg.test(obj) === false) {
    return false
  }

  return true
};

// 取身份证前两位,校验省份
const checkProvince = function (obj) {
  const province = obj.substr(0, 2)

  if (vcity[province] === undefined) {
    return false
  }

  return true
}

// 检查生日是否正确
function checkBirthday (obj) {
  const len = obj.length

  // 身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
  if (len === 15) {
    const reFifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/

    const arrData = obj.match(reFifteen)
    const year = arrData[2]
    const month = arrData[3]
    const day = arrData[4]
    const birthday = new Date(`19${year}/${month}/${day}`)

    return verifyBirthday(`19${year}`, month, day, birthday)
  }

  // 身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
  if (len === 18) {
    const reEighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/
    const arrData = obj.match(reEighteen)
    const year = arrData[2]
    const month = arrData[3]
    const day = arrData[4]
    const birthday = new Date(`${year}/${month}/${day}`)

    return verifyBirthday(year, month, day, birthday)
  }

  return false
};

// 校验日期
function verifyBirthday (year, month, day, birthday) {
  const now = new Date()
  const nowYear = now.getFullYear()

  // 年月日是否合理
  if (+birthday.getFullYear() === +year && +(birthday.getMonth() + 1) === +month && +birthday.getDate() === +day) {
    // 判断年份的范围（3岁到100岁之间)
    const time = nowYear - year

    if (time >= 0 && time <= 130) {
      return true
    }

    return false
  }

  return false
};

// 校验位的检测
function checkParity (obj) {
  // 15位转18位
  obj = changeFifteenToEighteen(obj)
  const len = obj.length

  if (len === 18) {
    const arrInt = [
      7,
      9,
      10,
      5,
      8,
      4,
      2,
      1,
      6,
      3,
      7,
      9,
      10,
      5,
      8,
      4,
      2,
    ]
    const arrCh = [
      '1',
      '0',
      'X',
      '9',
      '8',
      '7',
      '6',
      '5',
      '4',
      '3',
      '2',
    ]
    let cardTemp = 0
    let i
    let valnum = 0

    for (i = 0; i < 17; i++) {
      cardTemp += obj.substr(i, 1) * arrInt[i]
    }

    valnum = arrCh[cardTemp % 11]

    if (valnum === obj.substr(17, 1)) {
      return true
    }

    return false
  }

  return false
};

function changeFifteenToEighteen (obj) {
  if (obj.length === 15) {
    const arrInt = [
      7,
      9,
      10,
      5,
      8,
      4,
      2,
      1,
      6,
      3,
      7,
      9,
      10,
      5,
      8,
      4,
      2,
    ]
    const arrCh = [
      '1',
      '0',
      'X',
      '9',
      '8',
      '7',
      '6',
      '5',
      '4',
      '3',
      '2',
    ]
    let cardTemp = 0; let i
    obj = `${obj.substr(0, 6)}19${obj.substr(6, obj.length - 6)}`

    for (i = 0; i < 17; i++) {
      cardTemp += obj.substr(i, 1) * arrInt[i]
    }

    obj += arrCh[cardTemp % 11]

    return obj
  }

  return obj
};
